import Facility                         from "../../../domain/facility/Facility";
import FacilityId                       from "../../../domain/facility/FacilityId";
import FacilityName                     from "../../../domain/facility/FacilityName";
import FacilityWebReservationTargetType from "../../../domain/facility/FacilityWebReservationTargetType";
import { FacilityResponseType }         from "../../api/facility/FacilityResponseType";

export const toFacility = (source: FacilityResponseType): Facility => new Facility(
  new FacilityId(source.id),
  new FacilityName(source.name),
  toTargetType(source.target_type),
);

const toTargetType = (source: string): FacilityWebReservationTargetType => {
  switch (source) {
    default:
    case FacilityWebReservationTargetType.AVAILABLE:
      return FacilityWebReservationTargetType.AVAILABLE;
    case FacilityWebReservationTargetType.NOT_AVAILABLE:
      return FacilityWebReservationTargetType.NOT_AVAILABLE;
  }
};
